import { JsonPipe, CurrencyPipe, DatePipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { IMiPrelimBillingLines } from 'src/app/shared/interfaces';

@Component({
  selector: 'app-mi-invoice-billing-lines',
  standalone: true,
  imports: [JsonPipe, CurrencyPipe, DatePipe],
  templateUrl: './mi-invoice-billing-lines.component.html',
  styleUrl: './mi-invoice-billing-lines.component.scss',
})
export class MiInvoiceBillingLinesComponent {
  @Input() miBillingLines: IMiPrelimBillingLines[];
}
